<template>
  <LayoutHome>
    <div class="bread-crumb">
      首页 > Banner详情
    </div>
    <div class="news-detail">

      <div
        v-for="item in bannerlist"
        :key="item.id"
      >
        <div v-if="item.id==bannerId">
          <div class="title">{{item.title}}</div>
          <div class="uptime">&nbsp;</div>
          <div class="content">
            <div class="line"></div>
            <div v-html="item.typeContent"></div>
          </div>
       </div>
      </div>

      <!-- <div class="title">{{this.title}}</div>
      <div class="uptime">{{ newInfo.createTime }}</div>
      <div class="content">
        <div class="line"></div>
        <div v-html="this.content"></div>
      </div> -->
    </div>
  </LayoutHome>
</template>
<script>
import LayoutHome from "./../../components/Layout";
import moment from "moment";
export default {
  components: {
    LayoutHome,
  },
  data() {
    return {
      bannerlist: [],
      bannerId: this.$route.query.id,
      title:'',
      content:''
    };
  },
  created() {
    this.getBannerlist();
  },
  methods: {
    async getBannerlist() {
      const bannerlist = await this.$get("/fore/newsType/findHomePageBanner", {
        positionId: 1
      });
      this.bannerlist = bannerlist;
      // console.log(this.bannerInfo);
      // if(this.bannerInfo.id == this.$route.query.id){
      //   this.title = this.bannerInfo.title;
      //   this.content = this.bannerInfo.typeContent;
      //   console.log('asdfasdfasdf');
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.bread-crumb {
  width: 1200px;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 20px;
  margin: 20px auto 16px;
  .link {
    color: #666;
    font-size: 14px;
  }
}
.news-detail {
  background: #fff;
  width: 1200px;
  margin: 0 auto 16px;
  padding: 38px 50px 50px;
  border-top: solid 3px #2e47ae;
}
.news-detail .title {
  font-size: 26px;
  line-height: 37px;
  color: #2a2a2a;
  text-align: center;
}
.news-detail .uptime {
  font-size: 14px;
  line-height: 20px;
  color: #666;
  text-align: center;
  margin: 14px 0 24px 0;
}
.content {
  width: 800px;
  margin: 0 auto;
}
.line {
  border-bottom: solid 1px #eee;
  margin-bottom: 25px;
}
/deep/ .content img {
  width: 100%;
}
</style>